import { useTranslation } from 'react-i18next';
import { ScrollArea } from '@components/ui/ScrollArea/ScrollArea';
import styles from './DocumentGrid.module.css';

const CARDS = 18;
const NAME_WIDTHS = ['78%', '62%', '85%', '54%', '70%', '60%'];

/** Loading placeholder for the card grid — the table skeleton's counterpart. */
export function DocumentGridSkeleton() {
  const { t } = useTranslation();
  return (
    <ScrollArea
      orientation="both"
      className={styles.gridWrap}
      viewportClassName={styles.gridBody}
      viewportProps={{ role: 'status', 'aria-label': t('documents.loading') }}
    >
      <div className={styles.grid} aria-hidden="true">
        {Array.from({ length: CARDS }, (_, i) => (
          // The fade sits on the wrapper: the card's own opacity is the pulse.
          <div key={i} className={styles.skeletonSlot} style={{ '--slot': i } as React.CSSProperties}>
            <div className={`${styles.card} ${styles.skeletonCard}`}>
              <span className={`${styles.preview} ${styles.skeletonPreview}`} />
              <span className={styles.caption}>
                <span className={styles.skeletonBar} style={{ width: NAME_WIDTHS[i % NAME_WIDTHS.length] }} />
                <span className={`${styles.skeletonBar} ${styles.skeletonBarSub}`} />
              </span>
            </div>
          </div>
        ))}
      </div>
    </ScrollArea>
  );
}
